// Module
var code = `<template class="mdc-file">
	<require from="./file.scss"></require>
	<label for="files">
		<mdc-icon>upload</mdc-icon>
		<span mdc-headline6>Choose a file</span><span style="opacity: .8"> or drag it here.</span>
	</label>
	<input disabled.bind="disabled" readonly.bind="readonly" type="file" multiple.bind="multiple" files.two-way="files" id="files" ref="input" accept.bind="accept">
</template>
`;
// Exports
export default code;